// Icon names come from server data and are only known at runtime, hence the map. A new name
// needs an import and an entry here.
import aboutIcon from 'shared/images/icons/about.svg'
import allgemeinwissenIcon from 'shared/images/icons/allgemeinwissen.svg'
import biologieIcon from 'shared/images/icons/biologie.svg'
import chatBubblesIcon from 'shared/images/icons/chat-bubbles.svg'
import chatsIcon from 'shared/images/icons/chats.svg'
import chemieIcon from 'shared/images/icons/chemie.svg'
import contentoverviewIcon from 'shared/images/icons/contentoverview.svg'
import deutschIcon from 'shared/images/icons/deutsch.svg'
import editIcon from 'shared/images/icons/edit.svg'
import elektrotechnikIcon from 'shared/images/icons/elektrotechnik.svg'
import englischIcon from 'shared/images/icons/englisch.svg'
import enterpriseIcon from 'shared/images/icons/enterprise.svg'
import erdkundeIcon from 'shared/images/icons/erdkunde.svg'
import fileIcon from '@fortawesome/fontawesome-free/svgs/regular/file-lines.svg'
import geschichteIcon from 'shared/images/icons/geschichte.svg'
import heartOutlineIcon from 'shared/images/icons/heart-outline.svg'
import informatikIcon from 'shared/images/icons/informatik.svg'
import ingenieurwissenschaftenIcon from 'shared/images/icons/ingenieurwissenschaften.svg'
import inhalteIcon from 'shared/images/icons/inhalte.svg'
import jobsIcon from 'shared/images/icons/jobs.svg'
import juraRechtIcon from 'shared/images/icons/jura-recht.svg'
import kebabMenuIcon from 'shared/images/icons/kebab-menu.svg'
import lernplaeneIcon from 'shared/images/icons/lernplaene.svg'
import lightbulbIcon from 'shared/images/icons/lightbulb.svg'
import lockIcon from 'shared/images/icons/lock.svg'
import logoutIcon from 'shared/images/icons/logout.svg'
import mathematikIcon from 'shared/images/icons/mathematik.svg'
import medizinIcon from 'shared/images/icons/medizin.svg'
import paedagogikPsychologieIcon from 'shared/images/icons/paedagogik-psychologie.svg'
import physikIcon from 'shared/images/icons/physik.svg'
import playlistIcon from 'shared/images/icons/playlist.svg'
import profileIcon from 'shared/images/icons/profile.svg'
import pupilIcon from 'shared/images/icons/pupil.svg'
import raketeIcon from 'shared/images/icons/rakete.svg'
import repeatIcon from 'shared/images/icons/repeat.svg'
import settingsIcon from 'shared/images/icons/settings.svg'
import sparklesIcon from 'shared/images/icons/sparkles.svg'
import statistikIcon from 'shared/images/icons/statistik.svg'
import studentIcon from 'shared/images/icons/student.svg'
import studientippsIcon from 'shared/images/icons/studientipps.svg'
import themenIcon from 'shared/images/icons/themen.svg'
import traineeIcon from 'shared/images/icons/trainee.svg'
import verifiedUserIcon from 'shared/images/icons/verified-user.svg'
import videoIcon from 'shared/images/icons/video.svg'
import wirtschaftIcon from 'shared/images/icons/wirtschaft.svg'
import wirtschaftsinformatikIcon from 'shared/images/icons/wirtschaftsinformatik.svg'
import wirtschaftsingenieurwesenIcon from 'shared/images/icons/wirtschaftsingenieurwesen.svg'

const ICON_URLS_BY_NAME: Record<string, string> = {
  about: aboutIcon,
  allgemeinwissen: allgemeinwissenIcon,
  biologie: biologieIcon,
  chats: chatsIcon,
  chemie: chemieIcon,
  'content-overview': contentoverviewIcon,
  deutsch: deutschIcon,
  edit: editIcon,
  elektrotechnik: elektrotechnikIcon,
  englisch: englischIcon,
  enterprise: enterpriseIcon,
  erdkunde: erdkundeIcon,
  file: fileIcon,
  geschichte: geschichteIcon,
  'heart-outline': heartOutlineIcon,
  informatik: informatikIcon,
  ingenieurwissenschaften: ingenieurwissenschaftenIcon,
  inhalte: inhalteIcon,
  jobs: jobsIcon,
  'jura-recht': juraRechtIcon,
  'kebab-menu': kebabMenuIcon,
  lernplaene: lernplaeneIcon,
  lightbulb: lightbulbIcon,
  logout: logoutIcon,
  mathematik: mathematikIcon,
  medizin: medizinIcon,
  'paedagogik-psychologie': paedagogikPsychologieIcon,
  physik: physikIcon,
  playlist: playlistIcon,
  profile: profileIcon,
  pupil: pupilIcon,
  rakete: raketeIcon,
  repeat: repeatIcon,
  settings: settingsIcon,
  sparkles: sparklesIcon,
  statistik: statistikIcon,
  student: studentIcon,
  studientipps: studientippsIcon,
  themen: themenIcon,
  trainee: traineeIcon,
  'verified-user': verifiedUserIcon,
  video: videoIcon,
  wirtschaft: wirtschaftIcon,
  wirtschaftsinformatik: wirtschaftsinformatikIcon,
  wirtschaftsingenieurwesen: wirtschaftsingenieurwesenIcon,

  // Aliases where the server's icon name is not the SVG filename.
  study: deutschIcon,
  trainings: raketeIcon,
  events: aboutIcon,
  studienfinder: studentIcon,
  fremdsprachen: chatBubblesIcon,
  'change-password': lockIcon,
}

export function resolveIconUrl(name: string): string | undefined {
  return ICON_URLS_BY_NAME[name]
}
